import React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { EmptyCard } from '@vlabs/shared/components/empty-card';
import { SampleWithActions } from '@vlabs/shared/components/sample/SampleWithActions';
import { CircleAnimatedButton, useWindowSize } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './EventSampleCell.module.sass';

export const EventSampleCell = ({
  original = {},
  onEventClick = undefined,
}) => {
  const { t } = useTranslation();
  const hasBody = !!original?.body_detections;
  const hasFace = !!original?.face_detections;
  const windowSize = useWindowSize();

  return (
    <div className={st.Root} data-testid="eventSampleCell">
      <div className={st.GoToButton}>
        <CircleAnimatedButton
          icon={<ArrowInCircleRightIcon />}
          onClick={onEventClick}
          onSurface
          size={windowSize.width < 1920 ? 'small' : 'medium'}
        >
          {t('events:page.title')}
        </CircleAnimatedButton>
      </div>
      {hasFace && (
        <SampleWithActions
          data-testid="eventSample"
          dataTip={t('events:проверьте настройки сценария')}
          imageUrl={original?.uiFaceDetection?.uiSampleURL}
          type="face"
        />
      )}
      {hasBody && (
        <>
          {hasFace && <span className={st.Divider} />}
          <SampleWithActions
            data-testid="eventSample"
            dataTip={t('events:проверьте настройки сценария')}
            imageUrl={original?.uiBodyDetection?.uiSampleURL}
            type="body"
          />
        </>
      )}
      {!hasFace && !hasBody && (
        <EmptyCard
          className={st.EmptyCard}
          data-testid="eventSample"
          onImageClick={onEventClick}
          text={t('no data.title')}
        />
      )}
    </div>
  );
};

EventSampleCell.propTypes = {
  original: PropTypes.object,
  onEventClick: PropTypes.func,
};
